;(function () {

"use strict";

var RegisterFormView = Backbone.View.extend({
  initialize: function (opts) {
    // console.log('init register form');
    // console.log(this.el);
    this.parent = opts.parent;
  },
  submit: function (e) {
    if (this.loading) { return false; }

    this.$el.find('.errors').remove();

    var pw = this.$el.find('input[name="customer[password]"]').val();
    if (!pw) { 
      this.error({err: {error: {'Password': ['is required'] }}});
      return false; 
    }

    this.loading = true;
    /* post to dev shopify */
    var url = "//dev.roseandrex.com/register";
    // var url = "http://localhost:3000/register";

    $.post(url, this.$el.serialize(), _.bind(function (d) {
      this.loading = undefined;

      if (d.err) {
        this.error(d);
      } else {
        this.login();
      }
    }, this));

    return false;
  },
  error: function (d) {
    this.$el.prepend($('<div class="errors"><ul></ul></div>'));
    var errors = '';

    _.each(d.err.error, function (err, key) { 
      if (key !== 'base') {
        err[0] = key + ' ' + err[0];
      }

      errors = '<li>' + err.join('<br/>') + '</li>';
    });

    this.$el.find('.errors ul').html(errors);
    this.parent.resize();
  },
  login: function () {
    var pw = this.$el.find('input[name="customer[password]"]').val();
    var email = this.$el.find('input[name="customer[email]"]').val();

    var $form = $('#CustomerLoginForm');
    $form.find('input[name="customer[password]"]').val(pw);
    $form.find('input[name="customer[email]"]').val(email);

    $form.find('form').trigger('submit', [ true ]);
  },
  events: {
    'submit': 'submit'
  }
});

var LoginFormView = Backbone.View.extend({
  initialize: function (opts) {
    // console.log('here updated');
    // console.log('new login form view');
    this.parent = opts.parent;
  },
  addMessage: function (msg) {
    if (!this.$el.find('.errors')[0]) {
      this.$el.prepend('<div class="errors"><ul></ul></div>');
    }

    this.$el.find('.errors ul li').remove();
    this.$el.find('.errors ul').append('<li class="custom-msg">'+msg+'</li>');

    this.parent.resize();
  },
  submit: function (e, skipValidation) {
    if (skipValidation) { return true; }

    var url = "//dev.roseandrex.com/login";
    
    $.post(url, { email: this.$el.find('input#CustomerEmail').val() }, _.bind(function (d) {

      if (d.status === 'disabled') {
        var msg = 'This account has not been activated yet.<br/> An email has been sent to this email address from care@roseandrex.com with instructions for how to activate it.';

        this.addMessage(msg);
      } else if (d.status === 'invited') {
        var msg = 'This account has not been activated yet.<br/> An email has been sent to this email address from care@roseandrex.com with instructions for how to activate it.';

        this.addMessage(msg);
      } else if (d.status === 'does-not-exist') {
        var msg = 'This account does not exist, please register.';

        this.addMessage(msg);
      } else {
        this.$el.trigger('submit', [ true ]);
      }
    }, this));

    return false;
  },
  events: {
    'submit': 'submit'
  }
})

var PageView = Backbone.View.extend({
  initialize: function () {
    new LoginFormView({ el: this.$el.find('.customer-login form'), parent: this });
    new RegisterFormView({ el: this.$el.find('.customer-register form'), parent: this });
    this.resize();

    // $('.recover-password-toggle').on('click', function (e) {
    //   console.log('here');

    //   $("#RecoverPasswordForm").toggle();
    //   $("#CustomerLoginForm").toggle();
    // })
  },
  resize: function () {
    var h = $("#CustomerRegisterForm").css('height', 'auto').height();

    // console.log(h);

    $('#CustomerLoginForm').height(h);
    $("#CustomerRegisterForm").height(h);
    $("#RecoverPasswordForm").height(h);
  }
});

module.exports = PageView;

}());